import { render, staticRenderFns } from "./omCenter.vue?vue&type=template&id=ea3cd284&"
import script from "./omCenter.vue?vue&type=script&lang=js&"
export * from "./omCenter.vue?vue&type=script&lang=js&"
import style0 from "./omCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports